import React, { useEffect, useState } from "react";
import fetchData from "../../api/fetchApi";
import Table from "../common/Table";

export default function MemberExpiryReport() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalMembers, setTotalMembers] = useState(0);
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    mobile: "",
    package_id: ""
  });

  const fetchMembers = async () => {
    setLoading(true);
    setError(null);
    try {
      let query = `chaat/members?per_page=${perPage}&page=${currentPage}&filter[not_expired]=&sort=expired_date`;
      if (filters.name) query += `&filter[name]=${encodeURIComponent(filters.name)}`;
      if (filters.email) query += `&filter[email]=${encodeURIComponent(filters.email)}`;
      if (filters.mobile) query += `&filter[mobile]=${encodeURIComponent(filters.mobile)}`;
      if (filters.package_id) query += `&filter[package_id]=${encodeURIComponent(filters.package_id)}`;
      const data = await fetchData(query);
      setMembers(data.data);
      setTotalMembers(data.meta.total);
      setCurrentPage(data.meta.current_page);
      setTotalPages(data.meta.last_page);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line
  }, [currentPage, perPage, filters]);

  const onFilter = () => {
    setCurrentPage(1);
    fetchMembers();
  };

  const columns = [
    { header: "المعرف", accessor: "id" },
    { header: "الاسم", accessor: "name" },
    { header: "البريد الإلكتروني", accessor: "email" },
    { header: "رقم الهاتف", accessor: "mobile" },
    { header: "تاريخ الانتهاء", accessor: "expired_date_at" },
    { header: "الباقة", accessor: "package", render: row => row.package ? row.package.package_name : "-" },
  ];

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <h2 className="font-bold text-xl mb-4">تقرير الأعضاء حسب تاريخ الانتهاء</h2>
      <Table
        columns={columns}
        rows={members}
        filters={filters}
        setFilters={setFilters}
        onFilter={onFilter}
        pagination={{
          title: "الأعضاء",
          label: `الصفحة ${currentPage} من ${totalPages}`,
          pages: Array.from({ length: totalPages }, (_, i) => i + 1),
          current: currentPage,
          last: totalPages,
          onPageChange: setCurrentPage,
          perPage: perPage,
          onPerPageChange: setPerPage,
        }}
      />
      {loading && <div className="text-center mt-4">جاري التحميل...</div>}
      {error && <div className="text-red-600 text-center mt-4">{error}</div>}
    </div>
  );
}